/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'underscore', 'assets/js/common/router/index', 'assets/js/modules/AjaxOperation'], function($, _, router, AjaxOperation) {
    var API_GET_CUSTOMER_LISTS = '/api/customers/{email}/mailing-lists';
    var API_GET_CUSTOMER_LIST = '/api/customers/{email}/mailing-lists/{listToken}';
    var API_CREATE_CUSTOMER_LIST = '/api/customers/{email}/mailing-lists';
    var API_REPLACE_CUSTOMER_LIST = '/api/customers/{email}/mailing-lists/{listToken}';

    var API_GET_LIST = '/api/mailing-lists/{listToken}';
    var API_GET_ITEMS = '/api/mailing-lists/{listToken}/items';
    var API_CREATE_LIST = '/api/mailing-lists';
    var API_UPDATE_LIST = '/api/mailing-lists/{listToken}';
    var API_REPLACE_LIST = '/api/mailing-lists/{listToken}';
    var API_DELETE_LIST = '/api/mailing-lists/{listToken}';

    var API_GET_LIST_FOR_CART_ITEM = '/api/carts/{cartToken}/items/{cartItemId}/mailing-list';
    var API_GET_ITEMS_FOR_CART_ITEM = '/api/carts/{cartToken}/items/{cartItemId}/mailing-list/items';
    var API_UPDATE_LIST_FOR_CART_ITEM = '/api/carts/{cartToken}/items/{cartItemId}/mailing-list';
    var API_ATTACH_LIST_TO_CART_ITEM = '/api/carts/{cartToken}/items/{cartItemId}/mailing-list/attach';
    var API_DETACH_LIST_FROM_CART_ITEM = '/api/carts/{cartToken}/items/{cartItemId}/mailing-list/{listToken}';

    var API_GET_PRICE = '/mailing-list/get-price/{mailingClass}/{itemId}/{quantity}';

    return {
        getMyLists: function() {
            return new AjaxOperation(
                { name: 'Load My Mailing Lists' },
                {
                    type: 'get',

                    url: function() {
                        var user = this.getObject().user;
                        return router.generate(API_GET_CUSTOMER_LISTS, { email: user.email });
                    },

                    data: function() {
                        if (this.getObject()) {
                            return _.pick(this.getObject(), 'page', 'sort', 'direction', 'limit');
                        }

                        return {};
                    }
                }
            );
        },

        getList: function() {
            return new AjaxOperation(
                { name: 'Load Mailing List' },
                {
                    type: 'get',

                    url: function() {
                        var user = this.getObject().user;
                        if (user && user.loggedIn) {
                            return router.generate(API_GET_CUSTOMER_LIST, { listToken: this.getObject().token, email: user.email });
                        } else {
                            return router.generate(API_GET_LIST, { listToken: this.getObject().token });
                        }
                    },

                    data: {}
                }
            );
        },

        getItemsByToken: function() {
            return new AjaxOperation(
                { name: 'Load Mailing List Items' },
                {
                    type: 'get',

                    url: function() {
                        if (this.getObject().cartToken && this.getObject().cartItemId) {
                            return router.generate(API_GET_ITEMS_FOR_CART_ITEM, {
                                cartToken: this.getObject().cartToken,
                                cartItemId: this.getObject().cartItemId
                            });
                        } else {
                            return router.generate(API_GET_ITEMS, { listToken: this.getObject().token });
                        }
                    },

                    data: function() {
                        if (this.getObject()) {
                            return _.pick(this.getObject(), 'page', 'sort', 'direction', 'limit', 'total');
                        }
                        return {};
                    },

                    ajaxSuccess: function(data) {
                        this.setFinished(AjaxOperation.SUCCESS, {
                            items: data,
                            token: this.getObject().token
                        });
                    },

                    ajaxError: function() {
                        this.setFinished(AjaxOperation.ERROR, {
                            token: this.getObject().token,
                            page: this.getObject().page
                        });
                    }
                }
            );
        },

        createList: function() {
            return new AjaxOperation(
                { name: 'Create Mailing List' },
                {
                    type: 'post',
                    contentType: 'application/json',

                    url: function() {
                        var user = this.getObject().user;
                        if (user && user.loggedIn) {
                            return router.generate(API_CREATE_CUSTOMER_LIST, { email: user.email });
                        } else {
                            return router.generate(API_CREATE_LIST);
                        }
                    },

                    data: function() {
                        return _.pick(this.getObject(), 'name', 'items', 'add_current_resident');
                    }
                }
            );
        },

        updateList: function() {
            return new AjaxOperation(
                { name: 'Update Mailing List' },
                {
                    type: 'patch',
                    contentType: 'application/json',

                    url: function() {
                        if (this.getObject().cartToken && this.getObject().cartItemId) {
                            return router.generate(API_UPDATE_LIST_FOR_CART_ITEM, {
                                cartToken: this.getObject().cartToken,
                                cartItemId: this.getObject().cartItemId
                            });
                        } else {
                            return router.generate(API_UPDATE_LIST, { listToken: this.getObject().token });
                        }
                    },

                    data: function() {
                        return _.pick(this.getObject(), 'name', 'items', 'add_current_resident');
                    }
                }
            );
        },

        replaceList: function() {
            return new AjaxOperation(
                { name: 'Replace Mailing List' },
                {
                    type: 'put',
                    contentType: 'application/json',

                    url: function() {
                        var user = this.getObject().user;
                        if (user && user.loggedIn) {
                            return router.generate(API_REPLACE_CUSTOMER_LIST, { listToken: this.getObject().token, email: user.email });
                        } else {
                            return router.generate(API_REPLACE_LIST, { listToken: this.getObject().token });
                        }
                    },

                    data: function() {
                        return _.pick(this.getObject(), 'name', 'add_current_resident', 'items');
                    }
                }
            );
        },

        deleteList: function() {
            return new AjaxOperation(
                { name: 'Delete Mailing List' },
                {
                    type: 'delete',
                    contentType: 'application/json',

                    url: function() {
                        return router.generate(API_DELETE_LIST, { listToken: this.getObject().token });
                    },

                    data: {}
                }
            );
        },

        getListForCartItem: function(cartToken, cartItemId) {
            return new AjaxOperation(
                { name: 'Get List For Cart Item' },
                {
                    type: 'get',

                    url: router.generate(API_GET_LIST_FOR_CART_ITEM, {
                        cartToken: cartToken,
                        cartItemId: cartItemId
                    }),

                    data: {}
                }
            );
        },

        attachListToCartItem: function(cartToken, cartItemId, token) {
            if (cartToken && cartItemId) {
                return new AjaxOperation(
                    { name: 'Attach List To Cart Item' },
                    {
                        type: 'put',
                        contentType: 'application/json',

                        url: router.generate(API_ATTACH_LIST_TO_CART_ITEM, { cartToken: cartToken, cartItemId: cartItemId }),

                        data: {
                            token: token
                        }
                    }
                );
            }
        },

        detachListFromCartItem: function(cartToken, cartItemId, token) {
            return new AjaxOperation(
                { name: 'Detach List From Cart Item' },
                {
                    type: 'delete',

                    url: router.generate(API_DETACH_LIST_FROM_CART_ITEM, {
                        cartToken: cartToken,
                        cartItemId: cartItemId,
                        listToken: token
                    }),

                    data: {}
                }
            );
        },

        getPrice: function() {
            return new AjaxOperation(
                { name: 'Get Price For Mailing Service' },
                {
                    type: 'get',

                    url: function() {
                        var obj = this.getObject();
                        return router.generate(API_GET_PRICE, {
                            mailingClass: obj.mailingClass,
                            itemId: obj.itemId,
                            quantity: obj.quantity
                        });
                    },

                    data: function() {
                        if (this.getObject()) {
                            return _.pick(this.getObject(), 'page', 'sort', 'direction', 'limit');
                        }

                        return {};
                    }
                }
            );
        }
    };
});
